import styles from './RealmTag.scss';

interface IRealmTag {
    realm: string;
}

const RealmTag = ({ realm }: IRealmTag) => {
    return <div className={styles.userRealmTag}>{realm}</div>;
};

export default RealmTag;
